import api from 'api/apiClient';
import { calculateAge, strToNumber } from 'modules/shared/utils';
import { normalizeStatus } from '../utils';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export const getCandidateDetails = async (id) => {
  if (!id) throw new Error('Candidate id is required');
  const { data: raw } = await unwrap(await api.get(`/api/hr/job-applicant/${id}`));

  const { bucket, workflow } = normalizeStatus(raw.application_status);

  return {
    id: raw.id,
    name: raw.candidate_name,
    age: raw.date_of_birth ? calculateAge(raw.date_of_birth) : null,
    gender: raw.gender,
    contact: raw.contact,
    email: raw.email,
    linkedInUrl: raw.linkedin_url,
    resumeUrl: raw.resume,
    additionalFileUrl: raw.additional_file,
    department: raw.department,
    designation: raw.designation,
    currentSalary: strToNumber(raw.current_salary),
    expectedSalary: strToNumber(raw.expected_salary),
    bucketStatus: bucket,
    workflowStatus: workflow,
    status: normalizeStatus(raw.application_status).workflow,
    nextInterview: raw.next_interview,
    currentInterviewRound: raw.current_interview_round,
    rejectionReason: raw.reason_for_rejection,
    experience: raw.experience,
    languages: raw.languages.map((l) => l.language).join(' '),
    skills: raw.skills,
    qualification: raw.qualification,
    currentEmployer: raw.current_employer,
    tools:
      raw.tools
        ?.split(';')
        .map((t) => t.split(':'))
        .filter(([k, v]) => k && v)
        .map(([k, v]) => ({
          name: k,
          status: v === 'true',
        }))
        .sort((a, b) => Number(b.status) - Number(a.status)) || [],
    whyJoin: raw.why_join,
  };
};

export const rejectCandidate = async (id, data) => {
  if (!id || !data) throw new Error('Candidate id and rejection reason is required');
  const payload = { action: 'reject', reason_for_rejection: data.reason };
  await unwrap(await api.put(`/api/hr/job-applicant/${id}/update-status`, payload));
};
